import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-modal-header"
}
const _hoisted_2 = {
  key: 0,
  class: "text-lg font-semibold text-gray-900 dark:text-gray-100"
}
const _hoisted_3 = {
  key: 1,
  class: "base-modal-footer"
}

import { computed } from 'vue'
import { X } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    modelValue: { type: Boolean },
    title: {},
    size: { default: 'md' },
    showClose: { type: Boolean, default: true },
    closeOnBackdrop: { type: Boolean, default: true },
    panelClass: {},
    bodyClass: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props



const sizeClass = computed(() => {
  const sizes: Record<string, string> = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  }
  return sizes[props.size] || sizes.md
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition-all duration-200 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "base-modal-backdrop",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.closeOnBackdrop && _ctx.$emit('update:modelValue', false)), ["self"])),
              "aria-modal": "true",
              role: "dialog"
            }, [
              _createVNode(_Transition, {
                "enter-active-class": "transition-all duration-300 ease-out",
                "enter-from-class": "opacity-0 translate-y-4 scale-95",
                "enter-to-class": "opacity-100 translate-y-0 scale-100",
                "leave-active-class": "transition-all duration-200 ease-in",
                "leave-from-class": "opacity-100 translate-y-0 scale-100",
                "leave-to-class": "opacity-0 translate-y-4 scale-95"
              }, {
                default: _withCtx(() => [
                  (_ctx.modelValue)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["base-modal-panel", [sizeClass.value, _ctx.panelClass]])
                      }, [
                        (_ctx.$slots.header || _ctx.title)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                              (_ctx.title)
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.title), 1))
                                : _createCommentVNode("", true),
                              _renderSlot(_ctx.$slots, "header"),
                              (_ctx.showClose)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "base-modal-close",
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                                  }, [
                                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sr-only" }, "Close", -1)),
                                    _createVNode(_unref(X), { class: "h-5 w-5" })
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["base-modal-body", _ctx.bodyClass])
                        }, [
                          _renderSlot(_ctx.$slots, "default")
                        ], 2),
                        (_ctx.$slots.footer)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _renderSlot(_ctx.$slots, "footer")
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})